import { Placeholder } from 'react-bootstrap'
import React from 'react'

export const SmallLoadingPlaceholder = () => {
  return (
    <Placeholder animation="glow">
      <Placeholder md={8} bg="primary" />
    </Placeholder>
  )
}
